import React from 'react'
import {
  TableBodyRow,
  TableBody,
} from 'src/components/TableComponents'
import { useTheme } from 'styled-components'
import * as S from '../../styles'
import { ReceivementProductWrapper } from '../../../ReceivementProductWrapper'
import { ReceivementBatchFinish, ReceivementProductFinish } from 'src/features/receivement/ReceivementTypes'
import { measureUnit, NumberFmt } from 'src/utils'
import { ReceivementFinishObservations } from '../../../ReceivementFinishObservations'

interface Props {
  product: ReceivementProductFinish
  headerColor?: string;
}

const DivergentProductTable = ({ product, headerColor }: Props) => {
  const theme = useTheme()

  const { batches } = product

  const isKg = batches.length > 0 ? batches[0].isKg : false
  const hasObservations = product.observations.length > 0

  const resolveTotalQuantity = () => batches.reduce((partialSum, batch) => partialSum + batch.totalQuantity, 0)
  const resolveTotalAcceptQuantity = () => batches.reduce((partialSum, batch) => partialSum + batch.acceptedQuantity, 0)
  const resolveTotalSwapQuantity = () => batches.reduce((partialSum, batch) => partialSum + batch.swapQuantity, 0)
  const resolveReturnQuantity = () => batches.reduce((partialSum, batch) => partialSum + batch.totalQuantity - batch.acceptedQuantity, 0)

  return (
    <>
      <ReceivementProductWrapper>
        <S.Table>
          <S.TableHeader
            backgroundColor={headerColor}
            columnInformation={[
              { columnName: 'Produto' },
            ]}
            flexColumns={[
              1,
            ]}
          />
          <TableBody style={{ marginBottom: hasObservations ? '8px' : '0px' }}>
            <TableBodyRow backgroundColor={theme.colors.white}>
              <S.TableBodyCell flex={1}>{product.productDescription}</S.TableBodyCell>
            </TableBodyRow>
            {hasObservations
            && <ReceivementFinishObservations observations={product.observations} modelId={product.modelId}/>}
          </TableBody>
          <S.TableHeader
            backgroundColor={theme.colors.gray}
            columnInformation={[
              { columnName: 'Lote' },
              { columnName: 'Qtd. Recebida' },
              { columnName: 'Qtd. a Aceitar' },
              { columnName: 'Troca Futura', tooltipMessage: 'Parte da Qtd. a Aceitar reservada para trocas futuras' },
              { columnName: 'Qtd. a Devolver' },
            ]}
            flexColumns={[
              0.15,
              0.15,
              0.15,
              0.15,
              0.4,
            ]}
            columnsBelow={[
              'Avaria',
              'Úteis',
              'Total',
            ]}
            belowAt='Qtd. a Devolver'
          />
          <TableBody>
            {batches.map((batch: ReceivementBatchFinish) => {
              const rejectedQuantity = batch.totalQuantity - batch.acceptedQuantity
              const hasMoreRejected: boolean = rejectedQuantity > batch.damageQuantity

              const damageQuantity: number = hasMoreRejected ? batch.damageQuantity : rejectedQuantity
              const utilsQuantity: number = hasMoreRejected ? rejectedQuantity - batch.damageQuantity : 0

              return (
                <TableBodyRow key={batch.batchId} backgroundColor={theme.colors.white}>
                  <S.TableBodyCell flex={0.15}>{batch.batchId}</S.TableBodyCell>
                  <S.TableBodyCell flex={0.15}><NumberFmt value={batch.totalQuantity} sufix={measureUnit(batch.isKg)} /></S.TableBodyCell>
                  <S.TableBodyCell flex={0.15}><NumberFmt value={batch.acceptedQuantity} sufix={measureUnit(batch.isKg)} /></S.TableBodyCell>
                  <S.TableBodyCell flex={0.15}><NumberFmt value={batch.swapQuantity} sufix={measureUnit(batch.isKg)} /></S.TableBodyCell>
                  <S.TableBodyCellGroup flex={0.4}>
                    <S.TableBodyCell flex={1 / 3}><NumberFmt value={damageQuantity} sufix={measureUnit(batch.isKg)} /></S.TableBodyCell>
                    <S.TableBodyCell flex={1 / 3}><NumberFmt value={utilsQuantity} sufix={measureUnit(batch.isKg)} /></S.TableBodyCell>
                    <S.TableBodyCell flex={1 / 3}><NumberFmt value={rejectedQuantity} sufix={measureUnit(batch.isKg)} /></S.TableBodyCell>
                  </S.TableBodyCellGroup>
                </TableBodyRow>
              )
            })}
          </TableBody>

          <S.TableHeader
            backgroundColor={theme.colors.gray}
            columnInformation={[
              { columnName: '' },
              { columnName: 'Total Recebido' },
              { columnName: 'Total a Aceitar' },
              { columnName: 'Total Troca Futura', tooltipMessage: 'Parte da Qtd. a Aceitar reservada para trocas futuras' },
              { columnName: 'Total a Devolver' },
            ]}
            flexColumns={[
              0.155,
              0.155,
              0.155,
              0.155,
              0.38,
            ]}
          />
          <S.TableBody>
            <TableBodyRow backgroundColor={theme.colors.white}>
              <S.TableBodyCell flex={0.155} />
              <S.TableBodyCell flex={0.155}><NumberFmt value={resolveTotalQuantity()} sufix={measureUnit(isKg)} /></S.TableBodyCell>
              <S.TableBodyCell flex={0.155}><NumberFmt value={resolveTotalAcceptQuantity()} sufix={measureUnit(isKg)} /></S.TableBodyCell>
              <S.TableBodyCell flex={0.155}><NumberFmt value={resolveTotalSwapQuantity()} sufix={measureUnit(isKg)} /></S.TableBodyCell>
              <S.TableBodyCell flex={0.38}><NumberFmt value={resolveReturnQuantity()} sufix={measureUnit(isKg)}/></S.TableBodyCell>
            </TableBodyRow>
          </S.TableBody>
        </S.Table>
      </ReceivementProductWrapper>
    </>
  )
}

export { DivergentProductTable }
